
<template>
    <b-modal
            size="lg"
            title="Provisión"
            cancel-title="Cancelar"
            ok-title="Guardar"
            no-close-on-backdrop
            no-close-on-esc
            class="modal-success"
            v-model="modalProvision"
            @ok="reg_provision"
            @cancel="btCancelar"
            >
            <b-card>
                <b-tabs content-class="mt-3">
                    <b-tab title="Provisión" active>
                        <b-row>
                            <b-col sm="2"> </b-col>
                            <b-col sm="1"> 
                                <label >Siniestro </label>
                            </b-col>
                            <b-col sm="3"> 
                                <b-form-input size="sm" type="text" v-model="datosSiniestro.nrosiniestro" disabled> </b-form-input> 
                            </b-col>

                            <b-col sm="1"> 
                                <label >Moneda </label>
                            </b-col>
                            <b-col sm="2"> 
                                <b-form-input size="sm" type="text" v-model="datosSiniestro.moneda" disabled> </b-form-input> 
                            </b-col>
                        </b-row>

                        <br>
                        
                        <b-col sm="12">
                            <b-row>
                            
                            <el-table hover 
                                ref="refTableDataBenef"
                                :data="dataProvision"
                                style="width: 100%"
                                border
                                max-height="1000px"
                                :row-class-name="tableRowClassName">
                            
                                <el-table-column 
                                    prop="codcobertura" 
                                    label="Cob." 
                                    width="90"
                                    align="center">
                                </el-table-column>
                            
                                <el-table-column 
                                    prop="descobertura" 
                                    label="Descripción"
                                    width="300"
                                    align="left">
                                </el-table-column>

                                <el-table-column 
                                    prop="mtoprovision" 
                                    label="Monto" 
                                    width="140"
                                    align="center">
                                    <template slot-scope="scope">
                                        <b-form-input 
                                            id="MTOPROVISION" 
                                            v-model="scope.row.mtoprovision" 
                                            size="sm" 
                                            v-mask="{ alias: 'decimal', integerDigits:10, digits:12, digitsOptional: true, groupSeparator: '.', radixPoint: ',', autoGroup: true, rightAlign: true , autoUnmask:true}"
                                            @change ="valCalcMonto2(scope.row)" 
                                            
                                            >
                                            </b-form-input>
                                    </template>
                                </el-table-column>

                                <el-table-column 
                                    prop="mtoprovisionpesos" 
                                    label="Monto Pesos" 
                                    width="140"
                                    align="center">
                                    <template slot-scope="scope">
                                        <b-form-input 
                                            id="MTOPROVISIONPESOS" 
                                            v-model="scope.row.mtoprovisionpesos" 
                                            size="sm" 
                                            v-mask="{ alias: 'decimal', integerDigits:10, digits:12, digitsOptional: true, groupSeparator: '.', radixPoint: ',', autoGroup: true, rightAlign: true , autoUnmask:true}"
                                            @input="valCalcMonto(scope.row)"
                                            ></b-form-input>
                                    </template>
                                </el-table-column>

                            </el-table>
                        </b-row>
                        <br>
                        <b-row>
                            <b-col sm="10"> </b-col>
                            
                            <b-col class="col-sm-per" sm ="2">
                                <b-form-checkbox
                                    id="idcknomina"
                                    ref="idcknomina"
                                    v-model="datosFormulario.cknomina"
                                    value="s"
                                    unchecked-value="n"
                                    @change="valNominado"
                                    
                                >
                                Nomina 
                                </b-form-checkbox>

                                
                            </b-col>

                        </b-row>
                        </b-col>
                    </b-tab>

              
                    <b-tab title="Beneficiarios">
                        <!-- <b-row>
                            <b-col sm="2"> </b-col>
                            <b-col sm="1"> 
                                <label >Siniestro </label>
                            </b-col>
                            <b-col sm="3"> 
                                <b-form-input size="sm" type="text" v-model="datosSiniestro.nrosiniestro" disabled> </b-form-input> 
                            </b-col>

                            <b-col sm="1"> 
                                <label >Moneda </label>
                            </b-col>
                            <b-col sm="2"> 
                                <b-form-input size="sm" type="text" v-model="datosSiniestro.moneda" disabled> </b-form-input> 
                            </b-col>
                        </b-row>

                        <br> -->
                        
                        <b-col sm="12">
                            <b-row align="right">
                                <el-table hover 
                                    ref="refTableDataBenef"
                                    :data="dataBeneficiarios"
                                    style="width: 100%"
                                    border
                                    max-height="1000px"
                                    :row-class-name="tableRowClassName">
                                
                                    <el-table-column 
                                        prop="sbecodbenef" 
                                        label="Cod." 
                                        width="90"
                                        align="center">
                                        <template slot-scope="scope">
                                            <b-form-input 
                                                id="SBECODBENEF" 
                                                size="sm" 
                                                type="number" 
                                                @change="buscar_beneficiario(scope.row.sbecodbenef)" 
                                                v-model="scope.row.sbecodbenef" 
                                                style="text-align:right">
                                            </b-form-input>
                                        </template>
                                    </el-table-column>
                                
                                    <el-table-column 
                                        prop="sbeidnacbenef"  
                                        label="Id. Nación"
                                        width="90"
                                        align="right">
                                    </el-table-column>

                                    <el-table-column 
                                        prop="sbenombenef" 
                                        label="Nombre" 
                                        width="280"
                                        align="left">
                                    </el-table-column>
                                    
                                    <el-table-column 
                                        prop="sbemoneda" 
                                        label="Mon." 
                                        width="60"
                                        align="center">
                                    </el-table-column>

                                    <el-table-column 
                                        prop="sbemonto" 
                                        label="Monto" 
                                        width="100"
                                        align="right">
                                        <template slot-scope="scope">
                                            <b-form-input 
                                                id="SBEMONTO" 
                                                v-model="scope.row.sbemonto" 
                                                size="sm" 
                                                v-mask="{ alias: 'decimal', integerDigits:10, digits:12, digitsOptional: true, groupSeparator: '.', radixPoint: ',', autoGroup: true, rightAlign: true , autoUnmask:true}"
                                                @blur="validarMonto()"
                                                ></b-form-input>
                                        </template>
                                    </el-table-column>

                                    <el-table-column align="center"
                                    width="60">
                                        <template slot-scope="scope">
                                            <b-button size="sm" variant="info" @click="deleteRow(scope.$index, scope.row)" style="color: #ffffff;" >
                                                <i class="fa fa-trash-o"></i>
                                            </b-button>
                                        </template>
                                    </el-table-column>

                                </el-table>
                            </b-row>
                            <br>
                            <b-row>
                                <b-col sm="6"> <p><b>Total Monto:</b> {{datosSiniestro.moneda}} {{this.$numeral(this.mtoTotal).format("0,0.00")}}</p></b-col>
                            </b-row>    
                            <b-row>
                                <b-col sm="6"> <p><b>Provision Beneficiario:</b> {{datosSiniestro.moneda}} {{this.$numeral(this.mtoProvision).format("0,0.00")}}</p></b-col>
                                
                                <b-col sm="6" align="right"> 
                                <b-button size="sm" variant="info" @click="addRow" style="color: #ffffff; margin-left: 10px;">Agregar</b-button>
                                <b-button size="sm" variant="success" @click="saveAll" style="color: #ffffff; margin-left: 10px;">Guardar todo </b-button> 
                                <!-- <b-button size="sm" variant="warning" @click="validarMonto" style="color: #ffffff; margin-left: 10px;">Calcular %</b-button> -->
                                </b-col> 
                            </b-row>
                        </b-col>
                    </b-tab>

                    
                    <b-tab title="Moneda">
                        <br>
                        <b-row>
                        <b-col lg="12">
                            <b-card>
                            <b-row>
                                <b-col lg="6"><b><p>Valores del día {{this.fecha}}</p></b></b-col>
                                <b-col lg="6">
                                <b-form-group label label-for="filtroProceso">
                                    <b-form-input
                                    id="filtroProceso"
                                    type="text"
                                    placeholder="Filtrar"
                                    v-model="filters[0].value"
                                    size="sm"
                                    ></b-form-input>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12">
                                <div ref="refTable">
                                    <data-tables
                                    ref="refTableData"
                                    :data="datamoneda"
                                    name="table"
                                    class="table-responsive"
                                    :current-page.sync="pagina"
                                    :table-props="tableProps"
                                    :filters="filters"
                                    :page-size="10"
                                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                                    layout="table"
                                    >
                                    <el-table-column
                                        v-for="title in titles"
                                        :min-width="title.minwidth"
                                        :prop="title.prop"
                                        :label="title.label"
                                        :key="title.label"
                                        :align="title.align"
                                        :formatter="formatter"
                                        sortable="custom"
                                        name="table"
                                        class="table-responsive"
                                        >
                                    </el-table-column>

                                    <!-- <el-table-column label="" min-width="100px" align="center">
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            v-for="button in customButtonsForRow(scope.row)"
                                            :key="button.id"
                                            :content="button.tooltip"
                                            placement="top">
                                            <b-button size="sm" variant="primary" type="text" @click="button.handler">
                                            <i v-bind:class="button.icon"></i>{{ button.name }}
                                            </b-button>
                                        </el-tooltip>
                                    </template>
                                    </el-table-column> -->
                                    </data-tables>
                                </div>
                                </b-col>
                            </b-row>
                            </b-card>
                        </b-col>  
                        </b-row>  

                        </b-tab>
                
                </b-tabs>

            </b-card>    
    </b-modal>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiGarProvision from "@/components/services/apiGarProvision";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';
import XLSX from "xlsx";


export default {
    name: "provision",
    mixins: [tablasMixin, globalesMixin, utilesMixin],
  
    props: {
        deDonde: String,
        estado: String, 
        moneda: String,
        nroSiniestro: Number,
        nroPoliza: Number,
        nroEndoso: Number,
        mtoAsegurado: Number,
        ejecutivo: String,
        asistente: String,
        fecRecpInform: Date,
        marcaPrec: String
    },

    components: {
        cSwitch,
        Datepicker,
        Multiselect
    },
    
    data: function() {
        return {
            tieneAcceso: false,
            es: es,
            busqueda: "",
            fecha: '',
            pagina: 1,
            paginaAnterior: 1,

            mtoProvision: 0,
            mtoTotal: 0,
        
            labelIcon: {
                dataOn: "\u2713",
                dataOff: "\u2715"
            },

            modalProvision: false,
            
            dataProvision :[],
            datamoneda:[],
            dataBeneficiarios:[],
            // tableData :[],

            flavours: [],
            
            allSelected: false,
            indeterminate: false,
            
            
            datosFormulario:{
                dedonde:"",
                cknomina: "",
                mtoprovisionold:"",
                mtoprovisionpesosold:""

                
            },

            datosSiniestro:{
                nrosiniestro:"",
                nroaviso:"",
                nropoliza:"",
                nroendoso:"",
                producto:"",
                moneda:"",
                feingreso:"",
                estado:"",
                codasegurado:"",
                rutasegurado:"",
                nomasegurado:"",
                codsujetoriesgo:"",
                rutsujetoriesgo:"",
                nomsujetoriesgo:"",
                mtoasegurado:"",
                fecrecpinform:"",
                marcaprec:"",
                codbeneficiario:"",
                rutbeneficiario:"",
                nombeneficiario:""
            },

            titles: [
                {
                prop: "codigo",
                label: "Código",
                align: "left",
                minwidth:'100'
                },
                {
                prop: "descripcion",
                label: "Descripción",
                align: "left",
                minwidth:'200'
                },
                {
                prop: "valor",
                label: "Valor",
                align: "right",
                minwidth:'150'
                }
                
            ],

            filters: [
                {
                value: '',
                filterFn: (row, filter) => {
                    return Object.keys(row).some(prop => {
                    
                    return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
                    })
                    
                }
                }
            ],
                
            titlesHistLiqu: [   
                {
                prop: "servicio",
                label: "Servicio",
                align: "center",
                minwidth:'80'
                },
                {
                prop: "codigo",
                label: "Código",
                align: "center",
                minwidth:'100'
                },
                {
                prop: "nombre",
                label: "Nombre",
                align: "center",
                minwidth:'250'
                },
                {
                prop: "feinicio",
                label: "Fecha Inicio",
                align: "center",
                minwidth:'100'
                },
                {
                prop: "fetermino",
                label: "Fecha Término",
                align: "center",
                minwidth:'100'
                },
            ],
        };
    },        

    methods: {

        obt_datSiniestro(){
            // console.log(this.$route.query.nroSiniestro);
            this.datosFormulario.dedonde = this.$route.query.deDonde;
            this.datosSiniestro.estado = this.$route.query.estado;
            this.datosSiniestro.nrosiniestro = this.$route.query.nroSiniestro;
            this.datosSiniestro.nropoliza = this.$route.query.nroPoliza; 
            this.datosSiniestro.nroendoso = this.$route.query.nroEndoso; 
            this.datosSiniestro.mtoasegurado = this.$route.query.mtoAsegurado
            this.datosSiniestro.moneda = this.$route.query.moneda;
            this.datosSiniestro.fecrecpinform = this.$route.query.fecRecpInform;
            this.datosSiniestro.codbeneficiario = this.$route.query.codbenef; 
            this.datosSiniestro.rutbeneficiario = this.$route.query.idnacbenef; 
            this.datosSiniestro.nombeneficiario = this.$route.query.nombenef;

            this.tieneAcceso = true;
        },

        recuperar_Provi() {
            return apiGarProvision
                .recuperar_Provi(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.datosSiniestro.nrosiniestro,
                this.datosSiniestro.nropoliza,
                this.datosSiniestro.nroendoso

                )  
                .then(response => {
                response.data = this.keysMinuscula(response.data);
                
                this.dataProvision  = response.data.provision;
                this.datosFormulario.cknomina = response.data.args_out.nomina;


                var lista_data = this.dataProvision;
                for (var i = 0; i < lista_data.length; i++) {
                    if (lista_data[i]["descobertura"] === 'Beneficiario'){
                        this.mtoProvision = this.$numeral(lista_data[i]["mtoprovision"])._value;
                        // console.log(this.mtoProvision);
                        return;
                    }
                }


                
            })
            .catch(error => {
            this.crearNotificacion("Error de sistema", error, "error");
            });
        },

        recuperar_Beneficiarios() {

            return apiGarProvision
                .recuperar_beneficiarios(
                    this.$session.get("mail"),
                    this.$session.get("usuarioInterno"),
                    this.datosSiniestro.nrosiniestro,
                )  
                .then(response => {
                response.data = this.keysMinuscula(response.data);
                this.dataBeneficiarios  = response.data.res;
                
                var lista_data = this.dataBeneficiarios;
                for (var i = 0; i < lista_data.length; i++) {
                    this.mtoTotal += this.$numeral(lista_data[i]["sbemonto"])._value;
                }

            })
            .catch(error => {
                this.crearNotificacion("Error de sistema", error, "error");
            });
        },

        recuperar_moneda() {
            this.$Progress.start(); 
            return apiGarProvision
                .recuperar_moneda(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.cod_asegurado,
                this.participacion
                )  
                .then(response => {
                    response.data = this.keysMinuscula(response.data);
                    this.datamoneda = response.data.res;
                    // console.log(this.datamoneda);

                    this.fecha = response.data.args_out.fecha;
                    // console.log(response.data.args_out.fecha);
                    this.$Progress.finish();
                })
                .catch(error => {
                    this.mensaje= error;
                    this.variant="warning";
                    this.showAlert = true;
                    this.$Progress.finish();
                });
        },


        tableRowClassName({ row }) {
            if(row.marca == "1"){
                return 'danger-row';
            }
            else{
                return 'estiloFilaTabla';
            }
        },

        formatter(row, column) {
      
            if (column.property == "FECPAGO" && row[column.property]) {
                return this.configurarFechaLat(
                this.convierteFecha(row[column.property])
                )
            
            }
            else if ((column.property == "RECUMONTO" || column.property == "RECUMONTOPESOS" ||
                        column.property == "MONTO" || column.property == "MONTOPESOS" ||column.property == "TIPOCAMBIO" ||
                        column.property == "SDOSALDO" ) && row[column.property]){
                if (row[column.property] == 0 || row[column.property] == "0") {
                    return row[column.property];
                } else {
                    return this.$numeral(row[column.property]).format("0,0.00");
                }

            }
            else {
                return row[column.property];
            }
        },
        
        

        async valNominado(checked){

            if (checked === 's'){
                
                // Caso en estado activo, si no está activo se verá un mensaje: “Caso en estado XX no se puede marcar para nómina, revise” y no se podrá marcar la N
                if (this.$route.query.estado != 'ACT'){
                 
                    this.crearNotificacion("Atención", "Caso en estado " + this.$route.query.estado + " no se puede marcar para nómina, revise", "error"); 
                    await this.$nextTick();
                    this.datosFormulario.cknomina = "n"
                    return;
                }
                
                // Informe de liquidación ingresado en casilla “Fec. Recepción Informe” del control de gestión, si no hay informe se verá mensaje “Caso sin informe de liquidación no se puede marcar para nómina, revise” 
                // y no se podrá marcar la N
                if (this.$route.query.fecRecpInform === undefined){
                    this.crearNotificacion("Atención", "Caso sin informe de liquidación no se puede marcar para nómina, revise", "error"); 
                    await this.$nextTick();
                    this.datosFormulario.cknomina = "n"
                    return;
                 
                }

                // No debe tener marca Precautoria. Si la tiene,  se verá un mensaje: “Caso con Precautoria, no se puede marcar para nómina, revise” y no se podrá marcar la N.
                
                if(this.$route.query.marcaPrec === "s"){
                    
                    this.crearNotificacion("Atención", "Caso con Precautoria, no se puede marcar para nómina, revise", "error"); 
                    await this.$nextTick();
                    this.datosFormulario.cknomina = "n"
                    return;

                }
                
                
                var lista_data = this.dataProvision;
                for (var i = 0; i < lista_data.length; i++) {
                    
                    // Debe haber un monto ingresado en casilla beneficiario, si no lo hay se verá un mensaje: “Caso sin provisión no se puede marcar para nómina, revise” 
                    // y no se podrá marcar la N. Para hacer esta validación, considerará el monto ingresado en ese momento, lo que se ve en pantalla. Si hay monto ingresado, 
                    // continúa con la siguiente validación:
                    if (lista_data[i]["descobertura"] === 'Beneficiario' && (lista_data[i]["mtoprovision"] === "" || lista_data[i]["mtoprovision"] === undefined)){
                        this.crearNotificacion("Atención", "Caso sin provisión no se puede marcar para nómina, revise", "error"); 
                        await this.$nextTick();
                        this.datosFormulario.cknomina = "n"
                        return;
                        
                    }
                    
                    // El monto ingresado en casilla Beneficiario, en moneda póliza, no puede ser negativo ni mayor al monto asegurado, si es mayor al monto 
                    // asegurado verás mensaje: “Provisión mayor al monto asegurado, no se puede marcar para nómina, revise.” Y si es negativo se verá mensaje: “Provisión negativa, 
                    // no se puede marcar para nómina, revise.” En estos dos casos, no se podrá marcar la N.
                    if (lista_data[i]["descobertura"] === 'Beneficiario' && (this.$numeral(lista_data[i]["mtoprovision"])._value < 0)){
                        // this.datosFormulario.cknomina = "n";
                        this.crearNotificacion("Atención", "Provisión negativa, no se puede marcar para nómina, revise.", "error"); 
                        await this.$nextTick();
                        this.datosFormulario.cknomina = "n"
                        return;
                    }

                    if (lista_data[i]["descobertura"] === 'Beneficiario' && (this.$numeral(lista_data[i]["mtoprovision"])._value > this.$numeral(this.$route.query.mtoAsegurado)._value)){
                        // this.datosFormulario.cknomina = "n";
                        this.crearNotificacion("Atención", "Provisión mayor al monto asegurado, no se puede marcar para nómina, revise.", "error"); 
                        await this.$nextTick();
                        this.datosFormulario.cknomina = "n"
                        return;
                    }

                    

                }
                
            }
        
        },

        valCalcMonto(row) {

            console.log(row)
            
            if (row.mtoprovisionpesos != undefined || row.mtoprovisionpesos != "" ){
                
                row.mtoprovision = parseFloat(row.mtoprovisionpesos/row.tpcambio).toFixed(2);
            }

            if (row.descobertura != "Beneficiario" && row.mtoprovision < 0) {

                this.recuperar_Provi();
                this.crearNotificacion("Atención", "Provisión negativa, revise.", "error");
                return;
            }

            
            if (row.descobertura === "Beneficiario" && this.$route.query.estado === "ACT"){
            
                if (this.$numeral(row.mtoprovision)._value > this.$numeral(this.$route.query.mtoAsegurado)._value){

                    console.log(row.mtoprovision, this.$numeral(this.$route.query.mtoAsegurado)._value);
                    
                    this.recuperar_Provi();
                    this.crearNotificacion("Atención", "Provisión mayor al monto asegurado " + this.$route.query.moneda + " " + this.$numeral(this.$route.query.mtoAsegurado)._value + " revise.", "error");
                    return;
                    
                }

                if ( row.mtoprovision < 0) {
                    this.recuperar_Provi();
                    this.crearNotificacion("Atención", "Provisión negativa, revise.", "error");
                    return;
             
                } 
            }
        },

        valCalcMonto2(row) {

            if (row.descobertura != "Beneficiario" && row.mtoprovision < 0) {

                this.recuperar_Provi();
                this.crearNotificacion("Atención", "Provisión negativa, revise.", "error");
                return;
            }

            
            if (row.descobertura === "Beneficiario" && this.$route.query.estado === "ACT"){

                
            
                console.log('prueba de', this.$numeral(row.mtoprovision)._value , this.$numeral(this.$route.query.mtoAsegurado)._value);

                if (this.$numeral(row.mtoprovision)._value  > this.$numeral(this.$route.query.mtoAsegurado)._value){
                    
                    this.recuperar_Provi();
                    // this.crearNotificacion("Atención", "Provisión mayor al monto asegurado, revise.", "error");
                    this.crearNotificacion("Atención", "Provisión mayor al monto asegurado " + this.$route.query.moneda + " "+ this.$numeral(this.$route.query.mtoAsegurado)._value + " revise.", "error");
                    return;
                    
                }
                if ( row.mtoprovision < 0) {
                    this.recuperar_Provi();
                    this.crearNotificacion("Atención", "Provisión negativa, revise.", "error");
                    return;
             
                } 
            }
        },

        reg_provision(){

            this.$Progress.start();
            var provision = "";
            var i = 0;

            var lista_data = this.dataProvision;

            for (var i = 0; i < lista_data.length; i++) {

                if (lista_data[i]["mtoprovision"] != undefined || lista_data[i]["mtoprovisionpesos"] != undefined) { 

                //   this.valCalcMonto2(lista_data);
                    
                    provision += lista_data[i]["codcobertura"] + ',' + lista_data[i]["descobertura"] + ',' + 
                                 this.$numeral(lista_data[i]["mtoprovision"])._value + ',' + this.$numeral(lista_data[i]["mtoprovisionpesos"])._value + ',' + lista_data[i]["tpcambio"] + ';';
                }
            }
            
            if (provision != ""){
               provision = provision.slice(0, -1)
               apiGarProvision
                        .reg_provision(this.$session.get("mail"),
                                          this.$session.get("usuarioInterno"),
                                          this.$route.query.nroSiniestro,
                                          this.$route.query.moneda,
                                          this.datosFormulario.cknomina,
                                          provision

                    )
                    .then(response => {
                        this.$Progress.finish();
                        
                        this.crearNotificacion(
                            response.data.festado.resultado.titulo,
                            response.data.festado.resultado.mensaje,
                            response.data.festado.resultado.estado
                            );

                        this.$router.push({ path: 'CrearSiniestro', query: { deDonde: 'provision', 
                                                                     nroCorrespondencia: '',
                                                                     nroSiniestro: this.$route.query.nroSiniestro,
                                                                     nroPoliza: '',
                                                                     mtoDenunciado: '',
                                                                     ejecutivo: '',
                                                                     asistente: '' }});       
                    })
                    .catch(error => {
                        this.$Progress.finish();
                        this.crearNotificacion("Error de sistema", error, "error");
                        return;
                    });
                
            }  

        },

        btCancelar(){

            this.$router.push({ path: 'CrearSiniestro', query: { deDonde: 'provision', 
                                                                     nroCorrespondencia: '',
                                                                     nroSiniestro: this.$route.query.nroSiniestro,
                                                                     nroPoliza: '',
                                                                     ejecutivo: '',
                                                                     asistente: '' }});  

        },

        validarMonto: function () {
            var total=0;
            var totdiv=0;

            for (var i = 0; i < this.dataBeneficiarios.length; i++) {
                // total += Number(this.dataBeneficiarios[i].sbemonto);
                total += this.$numeral(this.dataBeneficiarios[i].sbemonto)._value
            }

            this.mtoTotal = total;

             if (this.mtoTotal.toFixed(2) > this.mtoProvision.toFixed(2) ) {
                console.log(Number(this.mtoTotal), Number(this.mtoProvision) )
                this.crearNotificacion("Atención", "Revise valores, el total debe ser igual a: " + this.mtoProvision.toFixed(2), "error");
                return 1;
            }

            
            
        },
    
        deleteRow(index, rows) {
            return apiGarProvision
            .delete_beneficiario(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                rows.sbesiniestro,
                rows.sbecodbenef
            )
            .then((response) => {
                response.data = this.keysMinuscula(response.data);
                
                console.log(rows);
                
                if (response.data.festado.resultado.estado != "error"){
                this.crearNotificacion(
                    "Insertar",
                    "Beneficiario eliminado exitosamente",
                    "success"
                );
                
                this.dataBeneficiarios.splice(index, 1);
                this.validarMonto();
                
                }
                else{
                
                this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
                }
                
            })
            .catch((error) => {
                this.mensaje= error;
                this.variant="danger";
                this.showAlert();
            });
        },

        saveRow(index, rows) { 
            
            return apiGarProvision
            .insert_update_beneficiario(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.nrosinietro,
                rows.SBECODBENEF,
                rows.SBEMONEDA, 
                rows.SBEMONTO
            )
            .then((response) => {
                response.data = this.keysMinuscula(response.data);
                if (response.data.festado.resultado.estado != "error"){
                this.crearNotificacion(
                    "Insertar",
                    "Beneficiario registrado exitosamente.",
                    "success"
                );
                }
                else{
                
                this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
                }
                
            })
            .catch((error) => {
                this.mensaje= error;
                this.variant="danger";
                this.showAlert();
            });
        },


        addRow:function(){

            // let newRow = {sbemonto: 0, 
            //                   sbemoneda: this.datosSiniestro.moneda 
            //                  };
            //     this.dataBeneficiarios = [newRow,...this.dataBeneficiarios];
            //     ++ this.addCount;


            this.existeBenefi = 0;
            this.dataBeneficiarios.forEach((column, index) => {
                console.log('SBECODBENEF',column["sbecodbenef"], this.datosSiniestro.codbeneficiario);
                
                if  (column["sbecodbenef"] == this.datosSiniestro.codbeneficiario) {
                this.existeBenefi = 1;
                }
            })
  

            if  (this.existeBenefi > 0) {
            
                let newRow = {sbemonto: 0, 
                              sbemoneda: this.datosSiniestro.moneda 
                             };
                this.dataBeneficiarios = [newRow,...this.dataBeneficiarios];
                ++ this.addCount;

            } else {
                
                let newRow = {sbecodbenef: this.datosSiniestro.codbeneficiario,
                              sbeidnacbenef: this.datosSiniestro.rutbeneficiario,
                              sbenombenef: this.datosSiniestro.nombeneficiario,
                              sbemoneda: this.datosSiniestro.moneda,
                              sbemonto: this.mtoProvision
                             };
                
                this.dataBeneficiarios = [newRow,...this.dataBeneficiarios];
                ++ this.addCount;
            }
        },

    
    buscar_beneficiario(p_beneficiario){
      this.$Progress.start();
      return apiGarProvision
        .buscar_beneficiario(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_beneficiario
        )
        .then((response) => {
            
            response.data = this.keysMinuscula(response.data);
            
            if (response.data.res.length > 0) {

                for (var key in this.dataBeneficiarios) {

                    if (this.dataBeneficiarios[key]["sbeidnacbenef"] == undefined) {
                    
                        this.dataBeneficiarios[key]["sbeidnacbenef"] = response.data.res[0].peridnacion;
                        this.dataBeneficiarios[key]["sbenombenef"] = response.data.res[0].pernombre;
                    }
                }
            }
            else {
                this.dataBeneficiarios[0]["sbeidnacbenef"] = ''; 
                this.dataBeneficiarios[0]["sbenombenef"] = '';
            }    
            this.$Progress.finish();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    saveAll:function(){

        if (this.validarMonto() != 1){

            this.dataBeneficiarios.forEach((column, index) => {
            console.log('monto.....', this.$numeral(column["sbemonto"])._value);
            if (column["sbecodbenef"] != undefined){
                return apiGarProvision
                .insert_update_beneficiario(
                    this.$session.get("mail"),
                    this.$session.get("usuarioInterno"),
                    this.$route.query.nroSiniestro,
                    column["sbecodbenef"],
                    column["sbemoneda"],
                    this.$numeral(column["sbemonto"])._value
                )
                .then((response) => {
                    
                    // console.log(this.$route.query.nroSiniestro, column["sbecodbenef"], column["sbemoneda"], Number(column["sbemonto"]));

                    response.data = this.keysMinuscula(response.data);
                    if (response.data.festado.resultado.estado != "error"){
                    this.crearNotificacion(
                        "Insertar",
                        "Beneficiario registrado exitosamente.",
                        "success"
                    );
                    }
                    else{
                    
                    this.crearNotificacion("Atención", response.data.festado.resultado.mensaje, "error");
                    }
                    
                })
                .catch((error) => {
                    this.mensaje= error;
                    this.variant="danger";
                    this.showAlert();
                })
            } else {
                this.crearNotificacion("Atención", "Debe ingresar un beneficiario", "success");
                return;
                
            }
            })   
        }
    },
    
    },

    

    
    mounted() {
        this.pagina = Number(this.$route.query.pagina);
        this.obt_datSiniestro();
        
        this.recuperar_Provi();
        this.recuperar_Beneficiarios();
        this.recuperar_moneda();
        this.modalProvision = true;
        
    },

    watch: {
        pagina: function(nuevo, anterior) {
        this.paginaAnterior = anterior;
        },
        
    }
};

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.label-blanco{
  color: #fff;
}

.col-sm-per{
    position: relative;
    width: 100%;
    padding-right: 5px;
    padding-left: 5px;
}

.derecha   { 
  float: right; 
  color: #20a8d8;
}
.izquierda { 
  float: left;  
}

</style>